import { useContext, useEffect, useState } from 'react';
import { Progress } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import { useSetFieldValue } from '@s20/components/forms/FormContext';
import JobWorkflowEditor from '../../../dispatch/JobWorkflowEditor';
import { DispatchContext } from '../DispatchContext';
import { useJobQueryKey } from '../common/useJobQueryKey.hook';
import { Job } from './Job';

export const Jobs = () => {
    const setFieldValue = useSetFieldValue();

    const { usCounties } = useContext(DispatchContext);

    const [selectedWorkflowJob, setSelectedWorkflowJob] = useState(false);

    const jobQuery = useJobQueryKey();
    const { data: jobs, isLoading } = useQuery(jobQuery);

    useEffect(() => {
        setFieldValue('jobsLoading', isLoading);
    }, [setFieldValue, isLoading]);

    return (
        <div className="w-100 flex-fill overflow-auto">
            {Boolean(isLoading) && <Progress />}

            {(jobs || []).map((job) => (
                <Job
                    key={job.id}
                    setSelectedWorkflowJob={setSelectedWorkflowJob}
                    {...job}
                />
            ))}

            <JobWorkflowEditor
                jobDetails={selectedWorkflowJob}
                usCounties={usCounties}
                onClose={() => {
                    setSelectedWorkflowJob(null);
                }}
            />
        </div>
    );
};